exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#form .div-header{\n  background-color: #fcfcfc;\n  padding-bottom: 15px;\n  padding-top: 12px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/apply-dialog/apply-dialog.component.css
// module id = ../../../../../src/app/pages/apply-dialog/apply-dialog.component.css
// module chunks = main